import { CreateGroupHasUserBulkInput, CreateGroupHasUserInput, CreateGroupHasUserResponse } from '@/models/gen/graphql';

import { CreateGroupHasUserBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { validateObj } from '@/utils/custom';

const validateGroupHasUser = validateObj({
  userId: (val: any): any => val || '',
  groupId: (val: any): any => val || '',
});

type CreateGroupHasUserBulkGraphApiResponse = GraphApiResponse<typeof CreateGroupHasUserBulkDocument>;

const createGroupHasUserBulkResponseSelector = (res: CreateGroupHasUserBulkGraphApiResponse): CreateGroupHasUserResponse[] =>
  !res.errors ? ((res?.createGroupHasUserBulk?.output || []) as CreateGroupHasUserResponse[]) : undefined;

const [runCreateGroupHasUserBulk] = graphApi(CreateGroupHasUserBulkDocument);

const createGroupHasUserBulk = async (groupHasUser: CreateGroupHasUserInput[]): Promise<CreateGroupHasUserResponse[]> => {
  const input: CreateGroupHasUserBulkInput = {
    values: groupHasUser.map(validateGroupHasUser),
  };

  const res = await runCreateGroupHasUserBulk({ input });
  const selected = createGroupHasUserBulkResponseSelector(res);

  return selected;
};

export const useCreateGroupHasUserBulk = createGraphApiHook(createGroupHasUserBulk);

export default createGroupHasUserBulk;
